module.exports = __webpack_public_path__ + "static/media/detail18.5a5aa159.jpg";